module.exports = __webpack_public_path__ + "static/404-a602764311995080aa1f3800aca71c31.gif";